// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__aIMmR","alert":"SettungsInbox_alert__IQnnR"};